import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[CheckInStrategy SetFilter] Action',
  ResetFilter: '[CheckInStrategy ResetFilter] Action',
}

const initialCheckInStrategyState: ICheckInStrategyState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface ICheckInStrategyState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-CheckInStrategy', whitelist: ['filter']},
  (
    state: ICheckInStrategyState = initialCheckInStrategyState,
    action: ActionWithPayload<ICheckInStrategyState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialCheckInStrategyState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
